import { render, staticRenderFns } from "./StatisticsBar.vue?vue&type=template&id=7c8e5cd8&scoped=true"
import script from "./StatisticsBar.vue?vue&type=script&lang=js"
export * from "./StatisticsBar.vue?vue&type=script&lang=js"
import style0 from "./StatisticsBar.vue?vue&type=style&index=0&id=7c8e5cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e5cd8",
  null
  
)

export default component.exports